import TimelineTitledTabTabsComponent from "./timeline-titled-tab-tabs-component";
import TimelineTitledTabTabsConfig from "./timeline-titled-tab-tabs-config";
import TimelineTitledTabTabsAdvancedConfig from "./timeline-titled-tab-tabs-advanced-config";

export default {
  TimelineTitledTabTabsComponent,
  TimelineTitledTabTabsConfig,
  TimelineTitledTabTabsAdvancedConfig
};
